export default class DDValidation {
  //fetchify validation
  constructor($module) {
    let token = document.getElementById("bc-fetchify");
    let tokenValue = token.getAttribute("data-token");
    let sortCodeFirst = document.getElementById("sortCodeFirst");
    let sortCodeSecond = document.getElementById("sortCodeSecond");
    let sortCodeThird = document.getElementById("sortCodeThird");
    let sortCode = document.getElementById("sortCode");
    let sortCodeInputs = document.querySelectorAll(".bc-input--sort-code");
    let accountNumber = document.getElementById("accountNumber");
    let accountNumberData = document.getElementById("accountNumberData");
    let sortCodeMax = document.querySelectorAll(
      ".bc-form-row--sort-code input"
    );

    sortCodeMax.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        if (checkbox.value.length > 2) {
          checkbox.value = checkbox.value.slice(0, 2);
        }
      });
    });

    sortCodeInputs.forEach((input) => {
      input.addEventListener("change", function () {
        sortCode.value =
          sortCodeFirst.value + sortCodeSecond.value + sortCodeThird.value;
        validation();
      });
    });

    accountNumberData.addEventListener("change", function () {
      accountNumber.value = accountNumberData.value;
      validation();
    });

    // disabled button

    let checkboxes = document.querySelectorAll('input[name="BankCheckbox"]');
    let buttonContinue = document.querySelector(
      ".bc-button-row > .bc-button[data-appearance='primary']"
    );

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        validation();
      });
    });

    function validation() {
      let checkboxFirst = document.getElementById("BankCheckbox-1");
      let checkboxSecond = document.getElementById("BankCheckbox-2");
      if (checkboxFirst.checked && checkboxSecond.checked) {
        setTimeout(function () {
          let validationFetchify = document.querySelectorAll(".cc-validate-ok");
          if (validationFetchify.length == 2) {
            buttonContinue.disabled = false;
          } else {
            buttonContinue.setAttribute("disabled", "disabled");
          }
        }, 500);
      } else {
        buttonContinue.setAttribute("disabled", "disabled");
      }
    }

    if (document.getElementById("cc_c2a") == null) {
      window.cc_c2a = new clickToAddress({
        accessToken: tokenValue,
      });
    }

    window.cc_c2a.addBankVerify({
      sort_code: "#sortCode",
      account_number: "#accountNumber",
    });
  }
}
